import React from 'react';
import { createContext, Dispatch, FC, SetStateAction, useContext, useState } from 'react';

const LoadingContext = createContext<[boolean, Dispatch<SetStateAction<boolean>>]>([false, (e) => e]);

const LoadingProvider: FC = ({ children }) => {
    const loading = useState<boolean>(false);
    return <LoadingContext.Provider value={loading}>{children}</LoadingContext.Provider>;
};

const useIsLoading = () => useContext(LoadingContext)[0];
const useSetLoading = () => useContext(LoadingContext)[1];

export { LoadingProvider, useIsLoading, useSetLoading };
